import {
  Alert,
  AlertIcon,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useReportFaultMutation } from "../../data/occupancy.api";
import QueryStateWrapper from "../QueryStateWrapper";
import ReactGA from "react-ga4";

type Props = {
  bookingId: string;
  isOpen: boolean;
  onClose: () => void;
};

const ReportFaultModal = ({ bookingId, isOpen, onClose }: Props) => {
  const reportFault = useReportFaultMutation(bookingId);
  const [reported, setReported] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    setReported(false);
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Report a Fault</ModalHeader>
        <ModalBody>
          {reported ? (
            <QueryStateWrapper
              isLoading={reportFault.isLoading}
              error={reportFault.error}
              data={reportFault.data}
            >
              <Alert status="success">
                <AlertIcon />
                Issue reported successfully. You will be contacted via the
                ISS-Helpdesk for further follow up if needed
              </Alert>
            </QueryStateWrapper>
          ) : (
            <Textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter details about the issue here"
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Flex gap={2}>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              isDisabled={message.length < 1}
              onClick={() => {
                if (!reported) {
                  reportFault.mutateAsync(message);
                } else {
                  onClose();
                }
                ReactGA.event({
                  category: "user_interaction",
                  action: `reported a fault`,
                });
                setReported(true);
              }}
              colorScheme="lancsBlue"
            >
              Confirm
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ReportFaultModal;
